module.exports = __webpack_public_path__ + "h5/img/bei.43754e59.png";